var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: { bus: _vm.busModal, "max-width": "calc(100vw - 135px)" },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function() {
            return [_c("v-spacer"), _c("v-spacer")]
          },
          proxy: true
        }
      ])
    },
    [
      _c("Title", {
        attrs: {
          title: "Carteira atual",
          subtitle: _vm.cliente ? _vm.cliente.name : ""
        }
      }),
      _c("MinhaCarteira", {
        attrs: {
          "bus-left": _vm.busLeft,
          bus: _vm.bus,
          "cliente-modal": _vm.cliente
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }